import { useRouter } from 'next/router';

import type { DropdownLink } from '@/components/Landing/Header/Desktop/NavDropdown';

export const useIsDropdownLinkActive = (link: DropdownLink) => {
  const { pathname } = useRouter();

  if (link.linkType !== 'internal' || typeof link.href !== 'string') {
    return false;
  }

  return pathname === link.href || pathname.startsWith(`${link.href}/`);
};
